import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        name: 'attendanceLogin',
        component: () => import('./components/attendanceLogin.vue'),
        path: '/attendanceLogin',
    },
    {
        name: 'devDev',
        component: () => import('./components/devDev.vue'),
        path: '/devDev',
    },
    {
        name: 'examinerDashboard',
        component: () => import('./components/Examiner/ExaminerDashboard.vue'),
        path: '/dashboard',
    },
    {
        name: 'AddUser',
        component: () => import('./components/Examiner/AddUser.vue'),
        path: '/add-user',
    },
    {
        name: 'ViewUsers',
        component: () => import('./components/Examiner/ViewUsers.vue'),
        path: '/view-users',
    },
    {
        name: 'courses',
        component: () => import('./components/Examiner/products/courses.vue'),
        path: '/courses',
    },
    {
        path: '/courses/:courseId',
        name: 'coursePage',
        component: () => import('./components/Examiner/products/coursePage.vue')
    },
    {
        name: 'ViewAircraft',
        component: () => import('./components/Examiner/products/ViewAircraft.vue'),
        path: '/view-aircraft',
    },
    {
        name: 'ViewChapters',
        component: () => import('./components/Examiner/products/ViewChapters.vue'),
        path: '/view-chapters',
    },
    {
        name: 'ViewSpecifics',
        component: () => import('./components/Examiner/products/ViewSpecifics.vue'),
        path: '/view-specifics',
    },
    {
        path: '/courses/:courseId/import-csv',
        name: 'importTasks',
        component: () => import('./components/Examiner/products/ImportTasks/ImportTasks.vue')
    },
    {
        path: '/courses/:courseId/import-csv/issues',
        name: 'IssuesDisplay',
        component: () => import('./components/Examiner/products/ImportTasks/issuesDisplay.vue')
    },
    {
        path: '/courses/:courseId/import-csv/import-successful',
        name: 'importSuccessful',
        component: () => import('./components/Examiner/products/ImportTasks/importSuccessful.vue')
    },
    {
        name: 'LoginPage',
        component: () => import('./components/Examiner/userLogin.vue'),
        path: '/',
    },
    {
        name: 'TemporaryLogin',
        component: () => import('./components/Examiner/TemporaryLogin.vue'),
        path: '/temp-login',
    },
    {
        name: 'ViewRevisions',
        component: () => import('./components/Examiner/ViewRevisions.vue'),
        path: '/view-revisions',
    },
    {
        name: 'ViewCourseRevisions',
        component: () => import('./components/Examiner/ViewCourseRevisions.vue'),
        path: '/view-course-revisions/:courseId',
    },
    {
        name: 'InstructorHome',
        component: () => import('./components/Instructor/InstructorHome.vue'),
        path: '/instructor-home',
    },
    {
        name: 'InstructorLogbook',
        component: () => import('./components/Instructor/InstructorLogbook.vue'),
        path: '/instructor-logbook/:logbookId',
    },
    {
        name: 'MultiSignOff',
        component: () => import('./components/Instructor/MultiSignOff.vue'),
        path: '/multi-so/:logbookId',
    },
    {
        name: 'ViewSessions',
        component: () => import('./components/Examiner/projects/ViewSessions.vue'),
        path: '/sessions',
    },
    {
        name: 'AddLogbook',
        component: () => import('./components/Examiner/logbooks/AddLogbook.vue'),
        path: '/add-logbook',
    },
    {
        name: 'ViewLogbooks',
        component: () => import('./components/Examiner/logbooks/ViewLogbooks.vue'),
        path: '/logbooks',
    },
    {
        name: 'ViewTraineeTable',
        component: () => import('./components/Examiner/trainees/ViewTraineeTable.vue'),
        path: '/trainees',
    },
    {
        name: 'ImportTrainees',
        component: () => import('./components/Examiner/trainees/ImportTrainees.vue'),
        path: '/import-trainees',
    },
    {
        path: '/import-trainees/issues',
        name: 'TraineeIssuesDisplay',
        component: () => import('./components/Examiner/trainees/TraineeIssuesDisplay.vue'),
    },
    {
        path: '/import-trainees/import-successful',
        name: 'TraineeImportSuccessful',
        component: () => import('./components/Examiner/trainees/TraineeImportSuccessful.vue'),
    },
    {
        name: 'ViewReports',
        component: () => import('./components/Examiner/reports/ViewReports.vue'),
        path: '/reports',
    },
    {
        name: 'TraineeReports',
        component: () => import('./components/Examiner/reports/TraineeReports.vue'),
        path: '/trainee-reports',
    },
    {
        name: 'TraineeReportsHTML',
        component: () => import('./components/Examiner/reports/TraineeReportsHTML.vue'),
        path: '/trainee-reports-html/:trainee_id',
    },
    {
        name: 'TimeOut',
        component: () => import('./components/Examiner/TimeOut.vue'),
        path: '/timeout',
    },
    {
        name: 'TraineeSignature',
        component: () => import('./components/Examiner/TraineeSignature.vue'),
        path: '/sign',
    },
    {
        name: 'ExaminerHelp',
        component: () => import('./components/Examiner/ExaminerHelp.vue'),
        path: '/help',
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    mode: "history",
    base: '/'
});

export default router;
